import { useState, useContext, useEffect, useRef } from 'react'
import { SceneContext } from './SceneContext'
import { useHistory }  from 'react-router-dom'
import MapButton from './MapButton'
import useMouse from '@react-hook/mouse-position'
import './css/Map.css'

export default function Map(props) {
    const [fade, setFade]   = useState('map-bkg opacity-off hide')
    const [ct, setCt]       = useState(0)
    const [label, setLabel] = useState('')
    const [labelPos, setLabelPos] = useState({top:0, left:0})

    const context = useContext(SceneContext)
    const history = useHistory()

    useEffect(()=> { 
        //context.deactivateAudioBox()
        //context.deactivateNavButton()

        if(context.display_map) {
            clearTimeout(ct)
            setFade('map-bkg opacity-on')
        } else {
            setFade('map-bkg opacity-off')
            setCt(setTimeout(() => setFade('map-bkg opacity-off hide'), 500))
        }
    }, [context.display_map])

    const generateButtons = () => {
        return context.map_data[context.daylight]?.nav?.map((d, i) => {
            return <MapButton data={d} index={i} key={'mb-'+i} type={'mapButton'} setLabel={setLabel} />
        })
    }

    const generateSceneRelatedButons = () => {
        if(context.scene_visible) {
            return context.selected_scene_data?.MapBoxes?.map((d, i) => {
                return <MapButton data={d} index={i} key={'msrb-'+i} type={'mapButtonScene'} setLabel={setLabel} />
            })
        }
    }

    const l =  history.location.pathname.charAt(1)
    const light_enabled = (l==='M' || l==='T' || l==='N')
    
    return (
        <div className={fade}>
            <img className={"mapa " + (light_enabled? context.daylight : '')} src="images/mapa/mapa.svg" />
            { generateButtons() }
            {/*<img src="images/mapa/close.svg" className={'close-map'} onClick={()=>context.change_display_map(false)} />
            <h1 className="go-to-label">{"Selecciona un destino"}</h1>*/}
            {/*<div className={'map-label-on'}>{label? (label): (context.selected_scene_data?.title)}</div>*/}
        </div>
    )
}